export default "__VITE_PUBLIC_ASSET__cc782061__"